module.exports = __webpack_public_path__ + "img/icon-error-warning.6d3ab259.svg";